import App from '../views/App.vue'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'

export default {
    App,
    Login,
    Dashboard
}
